import React from 'react'
import { Checkbox, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface TranslationCharacterAnalysisControlProps {
  checked: boolean
  disabled?: boolean
  helperText: React.ReactNode
  tooltip?: React.ReactNode
  onChange: (checked: boolean) => void
}

const TranslationCharacterAnalysisControl: React.FC<TranslationCharacterAnalysisControlProps> = ({
  checked,
  disabled = false,
  helperText,
  tooltip,
  onChange,
}) => {
  if (disabled) {
    return (
      <div className="translation-locked-row translation-locked-row--info" data-testid="tutorial:translation:character-analysis">
        <div className="translation-quality-label">
          <strong>Character Analysis</strong>
          {tooltip ? (
            <Tooltip title={tooltip}>
              <QuestionCircleOutlined />
            </Tooltip>
          ) : null}
        </div>
        <strong>Already completed for this book</strong>
      </div>
    )
  }

  return (
    <div className="translation-quality-control" data-testid="tutorial:translation:character-analysis">
      <div className="translation-quality-label">
        <strong>Character Analysis</strong>
        {tooltip ? (
          <Tooltip title={tooltip}>
            <QuestionCircleOutlined />
          </Tooltip>
        ) : null}
      </div>
      <Checkbox
        checked={checked}
        onChange={(event) => onChange(Boolean(event.target.checked))}
      >
        Run character analysis before translating.
      </Checkbox>
      <div className="translation-quality-helper">{helperText}</div>
    </div>
  )
}

export default TranslationCharacterAnalysisControl
